import React from 'react';
import classNames from 'classnames';

import { ButtonIcon } from '../../index';
import { DeleteBin4LineIcon } from '../../Icons';
import CheckLineIcon from '../../Icons/CheckLineIcon';

const GenericBlockEmptyStateWrapper = ({
    isEditable = false,
    isError = false,
    handleDeleteBlock,
    handleSubmit,
    bottomContent = null,
    children,
}) => {
    const contentContainerClassName = classNames('max-w-full flex gap-2.5', {
        'items-center': isError && isEditable,
        'items-end': !isError || !isEditable,
    });

    return (
        <div className="relative bg-purple-100 rounded-[10px] border-1 border-dashed border-purple-500 p-2.5 xs:p-4">
            {isEditable && (
                <div className="absolute top-2 right-2">
                    <ButtonIcon
                        type="neutral"
                        size="xs"
                        icon={DeleteBin4LineIcon}
                        onClick={handleDeleteBlock}
                    />
                </div>
            )}

            <div className="flex flex-col gap-2.5 p-2">
                <div className={contentContainerClassName}>
                    <div className="flex-1 max-w-[calc(100%-50px)] relative">{children}</div>

                    <ButtonIcon
                        type="secondary"
                        size="sm"
                        icon={CheckLineIcon}
                        state={!isEditable ? 'disabled' : 'default'}
                        onClick={handleSubmit}
                    />
                </div>

                {bottomContent}
            </div>
        </div>
    );
};

export default GenericBlockEmptyStateWrapper;
